<template>
    <div class="productos-home">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="add_product" title="Agregar producto">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Agregar producto</h3>
                <div>
                    <label for="">Nombre</label>
                    <input type="text" v-model="product_name">
                </div>
                <div>
                    <label for="">Precio</label>
                    <input type="number" min="0.00" max="10000.00" step="50" v-model="product_price">
                </div>
                <div>
                    <label for="">Categoria</label>
                    <b-select class="bselect" v-model="category_name">
                        <option v-for="(categoria, index) in categoriesList" :key="index" :value="categoria.name">{{categoria.name}}</option>
                    </b-select>
                </div>
                <input type="file" ref="select_file_product" name="photo" @change="imgSelected = !imgSelected" class="register-file" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp" />
                <div v-if="!imgSelected">
                    <label for="">Selecciona una imagen</label>
                    <button @click="$refs.select_file_product.click()"><i class="fa-solid fa-upload"></i></button>
                </div>
                <div v-if="imgSelected" class="selected-img">
                    <center>
                        <h5>Se ha seleccionado la imagen</h5><button @click="imgSelected = false">Cambiar</button>
                    </center>
                </div>
                <button @click="addProduct">Agregar producto</button>
            </div>
        </b-modal>
        <div>
            <div class="tabla">
                <center>
                    <h3>Productos</h3>
                    <div>
                        <input type="text" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                        <table v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="400">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Categoria</th>
                                    <th>Estado</th>
                                    <th>Precio</th>
                                    <th>Cantidad</th>
                                    <th>Detalles</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(product, index) in products" :key="index">
                                    <td>{{product.name}}</td>
                                    <td>{{product.category}}</td>
                                    <td>{{product.status === 'available' ? 'Disponible' : 'No disponible' }}</td>
                                    <td>{{priceFormat(product.price)}}</td>
                                    <td>{{product.unidades}}</td>
                                    <td><button><a :href="'/productos/' + encodeURIComponent(product.name) + '/profile'" target="_blank">Ver más</a></button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </center>
                <div class="function">
                    <center>
                        <div>
                            <button @click="$refs.add_product.show()">Agregar producto</button>
                            <button @click="$router.push('/inventarios')">Ver Inventario</button>
                            <button @click="$router.push('/categorias')">Ver categorias</button>
                        </div>
                    </center>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'
import Notify from '@/utils/Notification.js'

export default {
    name: 'productos-home',
    data() {
        return {
            products: [],
            allCants: null,
            allSells: null,
            bestProducts: [],
            stock: null,
            hoy: null,
            product_name: null,
            product_price: null,
            imgSelected: false,
            category_name: null,
            categoriesList: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            searchValue: '',
            host: process.env.INTERSEGUROS_IMAGEN
        }
    },
    watch: {
        searchValue: function() {
            if (this.searchValue === '') {
                this.products = []
                this.getAllProducts()
            }
        }
    },
    methods: {
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limit = 20
                this.offset = 0
                this.products = []
                this.getAllProducts()
            } else if (this.searchValue.length > 0) {
                this.limit = 20
                this.offset = 0
                this.products = []
                this.getAllProducts()
            }
        },
        onEnter () {
            this.searchProduct()
        },
        searchProduct() {
            this.modelSearch = false
            this.getAllProducts()
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.products.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getAllProducts()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        priceFormat: function(item) {
            return Price(item)
        },
        addProduct() {
            API.addProduct(this.category_name, {name: this.product_name, price: this.product_price})
                .then((res) => {
                    this.productUpdatePhoto(res.id)
                    Notify('dirty', 'Se ha agregado el producto con exito')
                })
        },
        uploadFile() {
            this.Images = this.$refs.file.files[0]
        },
        productUpdatePhoto (id) {
            var file = this.$refs.select_file_product.files
            if (!file.length) {
                return
            }

            this.saveImage(file[0], () => {
                API.productUpdatePhoto(this.productsPictureObject, id)
                    .then(result => {
                        this.$router.push('/productos/' + this.product_name + '/profile')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            })
        },
        saveImage (file, cb) {
            var reader = new FileReader()
            var vm = this
            reader.onload = (e) => {
                if (file.type === 'image/gif') {
                    vm.productsPicture = e.target.result
                    vm.productsPictureObject = file
                    if (cb) {
                        var toSend = {}
                        toSend.src = vm.productsPicture
                        cb(toSend)
                    }
                } else {
                    var image = new Image()
                    image.src = e.target.result
                    var width = 0
                    var height = 0
                    image.onload = function() {
                        width = this.width
                        height = this.height
                        var canvas = document.createElement('canvas')
                        var ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0)
                        var maxWidth = 400
                        var maxHeight = 400
                        if (width > height) {
                            if (width > maxWidth) {
                                height *= maxWidth / width
                                width = maxWidth
                            }
                        } else {
                            if (height > maxHeight) {
                                width *= maxHeight / height
                                height = maxHeight
                            }
                        }
                        canvas.width = width
                        canvas.height = height
                        ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0, width, height)
                        vm.productsPicture = canvas.toDataURL(file.type)
                        var byteString
                        if (vm.productsPicture.split(',')[0].indexOf('base64') >= 0) {
                            byteString = atob(vm.productsPicture.split(',')[1])
                        } else {
                            byteString = unescape(vm.productsPicture.split(',')[1])
                        }
                        var mimeString = vm.productsPicture.split(',')[0].split(':')[1].split(';')[0]
                        var ia = new Uint8Array(byteString.length)
                        for (var i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i)
                        }
                        try {
                            vm.productsPictureObject = new File([new Blob([ia], {type: mimeString})], file.type)
                        } catch (err) {
                            vm.productsPictureObject = new Blob([ia], {type: mimeString})
                            vm.productsPictureObject.name = file.name
                            vm.productsPictureObject.lastModifiedDate = new Date()
                        }

                        if (cb) {
                            cb(image)
                        }
                    }
                }
            }
            reader.readAsDataURL(file)
        },
        getAllProducts() {
            const limit = this.searchValue === '' ? this.limit : 'ALL'
            const offset = this.searchValue === '' ? this.offset : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.getAllProducts(limit, offset, searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.products = res
                    } else {
                        res.map(item => { this.products.push(item) })
                        this.offset += this.limit
                        this.itemFlag = true
                    }
                })
        },
        getCategories() {
            API.getCategories()
                .then((res) => {
                    this.categoriesList = res
                })
        },
        getInfoProducts() {
            API.getInfoProducts()
                .then((res) => {
                    this.allCants = res.cant
                    this.allSells = res.ventas
                    this.bestProducts = res.best
                    this.stock = res.stock
                    this.hoy = res.hoy
                })
        }
    },
    mounted() {
        this.getAllProducts()
        this.getInfoProducts()
        this.getCategories()
    }
}
</script>

<style scoped>
    h4 {
        margin-top: 20px
    }
    .productos-home {
        background-color: #cdcdcd;
        height: 100%;
    }
    .productos-home > div {
        display: flex;
    }
    .productos-home > div > .tabla {
        width: 100vw;
        padding: 20px;
        height: 70vh;
    }
    .productos-home > div > .tabla > center > div > input {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        text-align: center;
    }
    .productos-home > div > .tabla > .function {
        width: 100%;
        height: 20vh;
        padding-top: 20px;
    }
    .productos-home > div > .tabla > .function > center{
        padding: 20px;
        background-color: #63b78c;
        height: 100%;
        border-radius: 20px;
        position: relative;
    }
    .productos-home > div > .tabla > .function > center > div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }
    .productos-home > div > .tabla > .function > center > div > button{
        background-color: #e0b059;
        color: #fff;
        min-width: 50px;
        height: auto;
        border-radius: 30px;
        width: 200px;
        padding: 10px;
        margin-left: 15px;
        margin-right: 15px;
    }
    .productos-home > div > .info > center  {
        height: 100%;
        background-color: #63b1b7;
        border-radius: 20px;
        padding: 20px;
    }
    .productos-home > div > .tabla > center {
        height: 100%;
        background-color: #63b7a4;
        border-radius: 20px;
        padding: 20px;
        overflow-y: auto;
    }
    .productos-home > div > .tabla > center > h3 {
        color: #fff;
        padding: 20px;
    }
    .productos-home > div > .tabla > center > div > table {
        margin-top: 30px;
        border-radius: 20px;
    }
    .productos-home > div > .tabla > center > div > table > thead > tr {
        text-align: center;
        color: #fff;
        font-weight: bold;
        background-color: #2b2926;
    }
    .productos-home > div > .tabla > center > div > table > thead > tr > th {
        padding: 30px;
        border-style: double;
        width: 180px;
    }
    .productos-home > div > .tabla > center > div > table > tbody > tr {
        text-align: center;
        color: #fff;
        font-weight: bold;
    }
    .productos-home > div > .tabla > center > div > table > tbody > .approved {
        background-color: #22bb33;
    }
    .productos-home > div > .tabla > center > div > table > tbody > .block {
        background-color: #bb2124;
    }
    .productos-home > div > .tabla > center > div > table > tbody > .pending {
        background-color: #f0ad4e;
    }
    .productos-home > div > .tabla > center > div > table > tbody > tr > td {
        padding: 10px;
        border-style: double;
    }
    .productos-home > div > .tabla > center > div > table > tbody > tr > td > button{
        background-color: #e0b059;
        color: #fff;
        min-width: 50px;
        width: auto;
        height: 50px;
        border-radius: 30px;
    }
    .productos-home > div > .tabla > center > div > table > tbody > tr > td > button:hover{
        background-color: #fff;
        color: #e0b059;
    }
    .productos-home > div > .info > center > h3 {
        color: #fff;
        padding: 20px;
    }
    .productos-home > div > .info > center > div {
        padding: 20px;
        color: #fff;
        font-weight: bold;
    }
    .productos-home > div > .info > center > div > .info-a {
        padding: 20px;
        background-color: #2b2926;
        border-style: groove;
    }
    .productos-home > div > .info > center > div > .info-a > label {
        width: 100%;
        text-align: left;
        position: relative;
    }
    .productos-home > div > .info > center > div > .info-a > label > span {
        position: absolute;
        right: 0;
    }
    .productos-home > div > .info > center > div > .info-b {
        padding: 20px;
        background-color: #2b2926;
        border-style: groove;
    }
    .productos-home > div > .info > center > div > .info-b > label {
        width: 100%;
        text-align: left;
        position: relative;
    }
    .productos-home > div > .info > center > div > .info-b > label > span {
        position: absolute;
        right: 0;
    }
    .productos-home > div > .info > center > div > .info-c {
        padding: 20px;
        background-color: #2b2926;
        border-style: groove;
    }
    .productos-home > div > .info > center > div > .info-c > label {
        width: 100%;
        text-align: left;
        position: relative;
    }
    .productos-home > div > .info > center > div > .info-c > label > span {
        position: absolute;
        right: 0;
    }
    .productos-home > div > .info > center > div > .info-d {
        padding: 20px;
        background-color: #2b2926;
        border-style: groove;
    }
    .productos-home > div > .info > center > div > .info-d > label {
        width: 100%;
        text-align: left;
        position: relative;
    }
    .productos-home > div > .info > center > div > .info-d > label > span {
        position: absolute;
        right: 0;
    }
    .productos-home > div > .info > center > div > .info-e {
        margin-top: 20px;
    }
    .productos-home > div > .info > center > div > .info-e > table {
        margin-top: 75px;
        background-color: #2b2926;
        padding: 30px;
        border-style: groove;
        text-align: center;
        border-color: #fff;
        width: 100%;
    }
    .productos-home > div > .info > center > div > .info-e > table > tbody > tr > td {
        padding-left: 30px;
        padding-right: 30px;
        padding-top: 15px;
        padding-bottom: 15px;
        border-style: groove;
    }
    .info-wrapper > h3 {
        color: #000;
    }
    .info-wrapper > div {
        padding-top: 40px;
    }
    .info-wrapper > div > label {
        color: #000;
        font-size: 22px;
        margin-right: 15px;
    }
    .info-wrapper > div > input, .bselect{
        border-radius: 15px;
        width: 250px;
        text-align: center;
        height: 40px;
    }
    .info-wrapper > input[type=file] {
        display: none;
    }
    .info-wrapper > div > button {
        background-color: #e0b059;
        color: #fff;
        min-width: 50px;
        width: auto;
        height: 50px;
        border-radius: 30px;
    }
    .info-wrapper > div > center > button {
        background-color: #e0b059;
        color: #fff;
        min-width: 50px;
        width: auto;
        height: 50px;
        border-radius: 30px;
    }
    .info-wrapper > button {
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        margin-top: 30px;
    }
    .info-wrapper > .selected-img {
        background-color: chartreuse;
        padding: 10px;
        border-radius: 20px;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tienda/Productos.vue